import type { MapDefinition } from '../types';

const KEY = 'rollpick:custom-maps';

function isMapDefinition(value: unknown): value is MapDefinition {
  if (!value || typeof value !== 'object') return false;
  const map = value as Partial<MapDefinition>;
  return (
    typeof map.id === 'string' &&
    typeof map.name === 'string' &&
    typeof map.worldWidth === 'number' &&
    typeof map.worldHeight === 'number' &&
    typeof map.goalY === 'number' &&
    Array.isArray(map.walls) &&
    Array.isArray(map.pegs)
  );
}

export function getCustomMaps(): MapDefinition[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(isMapDefinition);
  } catch {
    return [];
  }
}

export function saveCustomMap(map: MapDefinition): MapDefinition[] {
  const maps = getCustomMaps();
  const next = [map, ...maps.filter((m) => m.id !== map.id)];
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function deleteCustomMap(id: string): MapDefinition[] {
  const next = getCustomMaps().filter((m) => m.id !== id);
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function importCustomMaps(maps: MapDefinition[]): MapDefinition[] {
  const current = getCustomMaps();
  const byId = new Map(current.map((m) => [m.id, m]));
  maps.filter(isMapDefinition).forEach((m) => byId.set(m.id, m));
  const next = Array.from(byId.values());
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}
